import { computed, getCurrentInstance, type ComputedRef } from 'vue';

// 動画要素のvid（`${prefix}-${uid}`形式）をprefixから一括生成するcomposable。
// useMoviePlayerVideoIds(['vid1', 'vid2', 'vid3'] as const) のように呼び出す。
export function useMoviePlayerVideoIds<T extends string>(prefixes: readonly T[]): Record<T, ComputedRef<string>> {
  const uid = getCurrentInstance()?.uid;
  // reduceの初期値{}はキー未確定のためRecord<T, ComputedRef<string>>には代入不可。
  // ループで全prefixのキーを埋め切ることを前提にキャストしている。
  return prefixes.reduce((acc, prefix) => {
    acc[prefix] = computed(() => `${prefix}-${uid}`);
    return acc;
  }, {} as Record<T, ComputedRef<string>>);
}
